// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`ProductCard UI Tests Renders correctly 1`] = `
<div
  className="h-full rounded-lg undefined bg-white border border-solid border-card-light  hover:shadow-3xl"
  data-testid="ProductCard-1"
  href={null}
>
  <div
    className="text-center py-8 px-4 md:py-6 md:px-6 leading-none text-[0px]"
  >
    <div
      className="overflow-hidden"
    >
      <picture
        className=""
        data-testid="mds-imageResolutions"
      >
        <source
          media="(min-width: 992px)"
          role="img"
          src={null}
          srcSet="https://placekitten.com/640/360"
        />
        <source
          data-testid="mds-imageResolutions-source-desktop"
          media="(min-width: 992px)"
          role="img"
          src={null}
          srcSet="https://placekitten.com/640/360"
          typeof="image/undefined"
        />
        <source
          media="(min-width: 768px)"
          role="img"
          src={null}
          srcSet="https://placekitten.com/640/360"
        />
        <source
          data-testid="mds-imageResolutions-source-tablet"
          media="(min-width: 768px)"
          role="img"
          src={null}
          srcSet="https://placekitten.com/640/360"
          typeof="image/undefined"
        />
        <source
          className="mb-6 md:mb-8 mx-auto !rounded-lg h-[172px] sm:h-[180px] max-w-[360px] rounded-none overflow-hidden lazyload"
          src="https://placekitten.com/640/360"
          srcSet={null}
          typeof="image/undefined"
        />
        <img
          className="mb-6 md:mb-8 mx-auto !rounded-lg h-[172px] sm:h-[180px] max-w-[360px] rounded-none overflow-hidden lazyload"
          data-testid="mds-imageResolutions-img"
          src="https://placekitten.com/640/360"
          srcSet={null}
        />
      </picture>
    </div>
  </div>
</div>
`;
